import { toast } from 'react-toastify';
import { CdsToastBody } from '.';
import { twColors } from '../../colors';
import {
  CdsToastProps,
  CdsToastType,
  CdsToastTypeColorMap,
  CdsToastUpdateProps,
} from './models';

export class CdsToast {
  static success(text: string, { toastId, ...props }: CdsToastProps = {}) {
    toast(
      ({ closeToast }) => (
        <CdsToastBody
          type={CdsToastType.Success}
          onClose={closeToast}
          message={text}
          {...props}
        />
      ),
      {
        progressStyle: {
          backgroundColor:
            twColors[CdsToastTypeColorMap[CdsToastType.Success]][500],
        },
        toastId,
      },
    );
  }

  static error(text: string, { toastId, ...props }: CdsToastProps = {}) {
    toast(
      ({ closeToast }) => (
        <CdsToastBody
          type={CdsToastType.Error}
          onClose={closeToast}
          message={text}
          {...props}
        />
      ),
      {
        progressStyle: {
          backgroundColor:
            twColors[CdsToastTypeColorMap[CdsToastType.Error]][500],
        },
        toastId,
      },
    );
  }

  static warning(text: string, { toastId, ...props }: CdsToastProps = {}) {
    toast(
      ({ closeToast }) => (
        <CdsToastBody
          type={CdsToastType.Warning}
          onClose={closeToast}
          message={text}
          {...props}
        />
      ),
      {
        progressStyle: {
          backgroundColor:
            twColors[CdsToastTypeColorMap[CdsToastType.Warning]][500],
        },
        toastId,
      },
    );
  }

  static info(text: string, { toastId, ...props }: CdsToastProps = {}) {
    toast(
      ({ closeToast }) => (
        <CdsToastBody
          type={CdsToastType.Default}
          onClose={closeToast}
          message={text}
          {...props}
        />
      ),
      {
        progressStyle: {
          backgroundColor:
            twColors[CdsToastTypeColorMap[CdsToastType.Default]][500],
        },
        toastId,
      },
    );
  }

  static dismiss(toastId: string) {
    toast.dismiss(toastId);
  }

  static loading(text: string, { toastId, ...props }: CdsToastProps = {}) {
    toast(
      ({ closeToast }) => (
        <CdsToastBody
          onClose={closeToast}
          message={text}
          showLoader={true}
          {...props}
        />
      ),
      {
        toastId,
        hideProgressBar: true,
      },
    );
  }

  static update(toastId: string, props: CdsToastUpdateProps) {
    toast.update(toastId, {
      render: ({ closeToast }) => (
        <CdsToastBody onClose={closeToast} {...props} />
      ),
      progressStyle: {
        backgroundColor:
          twColors[
            CdsToastTypeColorMap[props.type || CdsToastType.Default]
          ][500],
      },
      autoClose: 5000,
    });
  }
}
